const BILL_APPROVE_STATUS = {
  opened: "opened",
  processingAutomatic: "processing-automatic",
  processingManual: "processing-manual",
  submitted: "submitted",
  approved: "approved",
};

const BILL_PAYMENT_STATUS = {
  unpaid: "unpaid_bill_state",
  externally: "externally_paid_bill_state",
  paid: "paid_bill_state",
  processing: "processing_payment_bill_state",
  scheduled: "scheduled_payment_bill_state",
};

const BLOCKING_MODAL = {
  permissions: {
    title: (
      <>
        You do not have permission <br />
        to access this feature
      </>
    ),
    hint: "Contact your company Admin to request access",
    severity: "error",
  },
  feature: {
    title: "You came across a premium feature!",
    hint: "Contact support@controlhub.com to learn more",
  },
};

const INITIAL_BLOCKING_VALUES = {
  hasFeature: true,
  hasPermission: true,
};

const ALLOW_PERMISSIONS = {
  BILLS_ADMIN: "bills_admin",
  BILLS: "bills",
};

export {
  BILL_APPROVE_STATUS,
  BILL_PAYMENT_STATUS,
  BLOCKING_MODAL,
  INITIAL_BLOCKING_VALUES,
  ALLOW_PERMISSIONS,
};
